export default __webpack_public_path__ + "static/Moderat-Bold-Italic-825feed2e41d9dd1d6bb0e16d70a169a.woff2";